// extracted by mini-css-extract-plugin
export default {"banner":"EWWYbhf_ojxJFJYtZxhZ","link":"jBmNDKYsj7rLqXIg62Vp"};